import * as CalculatorStepTracker from "@omni/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@omni/services/tracking/trackers/tools/calculators/config";
import queryString from "query-string";
import { useEffect, useState } from "react";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

const WallpaperCalculator = () => {
    const [wallArea, setWallArea] = useState(0);
    const [windowArea, setWindowArea] = useState(0);
    const [doorArea, setDoorArea] = useState(0);
    const [rollArea, setRollArea] = useState(0);

    const [roll, setRoll] = useState<{ l?: string; w?: string }>({
        l: "0",
        w: "0"
    });
    const [walls, setWalls] = useState<{ h?: string; w?: string }[]>([
        { h: "0", w: "0" }
    ]);
    const [windows, setWindows] = useState<{ h?: string; w?: string }[]>([
        { h: "0", w: "0" }
    ]);
    const [doors, setDoors] = useState<{ h?: string; w?: string }[]>([
        { h: "0", w: "0" }
    ]);

    useEffect(() => {
        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.wallpaper);
    }, []);

    useEffect(() => {
        if (wallArea || windowArea || doorArea || rollArea) {
            CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.wallpaper);
        }
    }, [wallArea, windowArea, doorArea, rollArea]);

    useEffect(() => {
        const q = queryString.parse(location.search);

        q.walls &&
            setWalls(
                (q.walls as string).split(",").map((x) => {
                    const [h, w] = x.split("_");
                    return { h, w };
                })
            );
        q.doors &&
            setDoors(
                (q.doors as string).split(",").map((x) => {
                    const [h, w] = x.split("_");
                    return { h, w };
                })
            );
        q.windows &&
            setWindows(
                (q.windows as string).split(",").map((x) => {
                    const [h, w] = x.split("_");
                    return { h, w };
                })
            );
        q.roll &&
            setRoll(
                (q.roll as string).split(",").reduce(
                    (acc, curr, index) => {
                        if (index === 0) {
                            acc.l = curr;
                        } else {
                            acc.w = curr;
                        }
                        return acc;
                    },
                    { l: "0", w: "0" }
                )
            );
    }, []);

    const calculationProps = {
        calculateWallArea: (area: number) => setWallArea(area),
        calculateWindowArea: (area: number) => setWindowArea(area),
        calculateDoorArea: (area: number) => setDoorArea(area),
        calculateRollArea: (area: number) => setRollArea(area),
        walls,
        doors,
        windows,
        roll,
        setWalls,
        setDoors,
        setWindows,
        setRoll
    };

    const resultProps = {
        wallArea: wallArea,
        windowArea: windowArea,
        doorArea: doorArea,
        rollArea: rollArea,
        mailParams: {
            walls: walls
                .reduce(
                    (acc, wall) => [...acc, Object.values(wall).join("_")],
                    [] as string[]
                )
                .join(","),
            windows: windows
                .reduce(
                    (acc, window) => [...acc, Object.values(window).join("_")],
                    [] as string[]
                )
                .join(","),
            doors: doors
                .reduce(
                    (acc, door) => [...acc, Object.values(door).join("_")],
                    [] as string[]
                )
                .join(","),
            roll: Object.values(roll).join(",")
        }
    };

    return (
        <div id="calculator">
            <Calculation {...calculationProps} />
            <Result {...resultProps} />
        </div>
    );
};

export { WallpaperCalculator };
